/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/*******************************************************************************
 * Copyright     : Copyright (c)  2021 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : api.ts
 *
 * Project Title : APM Settings Tool
 *
 * Description   : API Redux Middleware
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : Dec 16, 2021
 *
 * @Version      : Version 1.0
 *
 *
 ******************************************************************************/

// @ts-nocheck
import axios, { AxiosResponse, AxiosError } from "axios";
import {
  IAPIPayload,
  apiCallBegan,
  apiCallFailed,
  apiCallSuccess,
} from "./apiActions";
import { appConfig } from "shared/utils";
import { setErrorNotification } from "stores/UIStore";

export const api =
  ({ dispatch }) =>
  (next) =>
  async (action) => {
    if (action.type !== apiCallBegan.type) {
      return next(action);
    }

    dispatch(setErrorNotification(null));

    const {
      url,
      method,
      data,
      params,
      responseType,
      onStart,
      onSuccess,
      onError,
    }: IAPIPayload = action.payload;

    if (onStart) {
      dispatch({ type: onStart });
    }

    next(action);

    try {
      const response: AxiosResponse = await axios.request({
        baseURL: appConfig.api_endpoint,
        url,
        method,
        params,
        responseType,
        data,
      });
      dispatch(apiCallSuccess(response.data));
      if (onSuccess) {
        dispatch({ type: onSuccess, payload: response.data });
      }
    } catch (error) {
      const {
        response,
        request,
      }: {
        response?: AxiosResponse;
        request?: XMLHttpRequest;
      } = error as AxiosError;

      let errorMessage = "";
      let errorDescription = "";
      if (response) {
        if (response.status === 400 && response.data?.status) {
          errorMessage = response.data.status;
          errorDescription = response.data.status;
        } else if (response.status === 502) {
          errorMessage = "Bad Gateway";
          errorDescription =
            "The server returned an invalid or incomplete response.";
        } else if (response.status === 503) {
          errorMessage = "Application is not available";
          errorDescription =
            "The application is currently not serving requests at this endpoint. It may not have been started or is still starting.";
        } else if (response.status === 404) {
          errorMessage =
            "The application is not serving the requested service.";
          errorDescription = "Service unavailable";
        } else {
          errorMessage = response.data?.errorMessage;
          errorDescription = response.data?.errorDescription;
        }
      } else if (request) {
        errorMessage = error.message;
        errorDescription = "Request failed. Please try again.";
      }

      dispatch(apiCallFailed(errorMessage));

      if (onError) {
        dispatch({
          type: onError,
          payload: { errorMessage, errorDescription },
        });
        dispatch(setErrorNotification({ errorMessage, errorDescription }));
      } else {
        dispatch(setErrorNotification({ errorMessage, errorDescription }));
      }
    }
  };
